module.exports = __webpack_public_path__ + "img/md-trending-down.65426337.svg";